module.exports = __webpack_public_path__ + "img/menu-lighter.48710872.svg";